<template>
  <div>
    <p class="is-size-5 has-text-danger">
      The project can be found
      <a href="http://github.com/manojap/reusable-vue-components">@ GitHub</a>
    </p>
  </div>
</template>

<script>
export default {
  name: "gitfooter",
  created() {},
  data() {
    return {};
  },
  props: {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
